import { Stack, Box, Paper, Button, Chip } from "@mui/material";
import ConfirmDialog from "@components/molecules/ConfirmDialog/ConfirmDialog";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import DataItem from "@components/atoms/DataItem/DataItem";
import ProfileImg from "../../../assets/images/profile.jpg";
import { IMyAccountUI } from "../../../types/organisms";
const MyAccountUI = ({
  showDialog,
  handleConfirmDialog,
  handleOpenDialog,
  handleCloseDialog,
  id,
  name,
  surname,
  phoneNumber,
  emailAddress,
  isAdmin
}: IMyAccountUI) => {
  const classes = {
    profile: {
      width: 200,
      height: 170,
      borderRadius: "100%",
      marginRight: 5,
      backgroundColor: "primary.main",
      backgroundImage: `url(${ProfileImg})`,
      backgroundSize: "cover"
    }
  };
  return <>
      <TitlePage title="Mi cuenta" subtitle="Accede a tu información personal y asegúrate de mantenerla siempre actualizada" />
      <Stack direction={"row"} marginTop={3} spacing={3} alignItems={"flex-start"}>
        <Paper elevation={12} sx={{
        width: 1,
        padding: "24px"
      }}>
          <TitlePaper title="Información del usuario" subtitle="Detalle completo de tu cuenta." />

          <Stack direction={"row"} marginTop={3}>
            <Box sx={classes.profile} />
            <Stack direction={"row"} flexWrap={"wrap"} width={1}>
              <DataItem label="Nombre" value={name} />
              <DataItem label="Apellido" value={surname} />
              <DataItem label="Estado" value={<Chip color="success" sx={{
              fontWeight: 600
            }} label="Activo" />} />
              <DataItem label="Identificación" value={id} />
              <DataItem label="Teléfono" value={phoneNumber ? phoneNumber : "N/A"} />
              <DataItem label="Correo" value={emailAddress ? emailAddress : "N/A"} />
              <DataItem label="Rol" value={isAdmin ? "Administrador" : "Usuario"} />
            </Stack>
          </Stack>
        </Paper>
        <Paper elevation={12} sx={{
        width: 400,
        padding: "24px"
      }}>
          <TitlePaper title="Salir del sistema" subtitle="Recuerda cerrar la sesión cada vez que lo consideres apropiado, para evitar el acceso a personas no autorizadas." />
          <Button onClick={handleOpenDialog} fullWidth sx={{
          marginTop: 3
        }}>
            Cerrar sesión
          </Button>
        </Paper>
      </Stack>
      <ConfirmDialog open={showDialog} cancelAction={handleCloseDialog} confirmAction={handleConfirmDialog} title="Cerrar sesión" subtitle="¿Estás seguro de que deseas cerrar la sesión?" message="Recuerda, que debes ingresar nuevamente las credenciales si deseas volver a entrar" cancelLabel="No cerrar" confirmLabel="Sí, cerrar" />
    </>;
};
export default MyAccountUI;